import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";

interface Props {
  setIsOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
  disabled?: boolean;
}

export function HelpCollapseButton({ setIsOpen, disabled }: Props) {
  return (
    <Button
      color={disabled ? "secondary" : "primary"}
      outline
      disabled={disabled}
      onClick={() => {
        setIsOpen((v) => !v);
      }}
      size="sm"
      className="ms-2"
    >
      <FontAwesomeIcon icon={faQuestionCircle} />
    </Button>
  );
}
